/**
 * Centraliza todas as query keys usadas no React Query
 * Facilita invalidação e organização das queries
 */

import ProductParams from "../../types/ProductParams";
import UfKit from "../../types/UfKit";
import {
  IntervaloParams,
  PrazoMedioParams,
  CondicoesParams,
  ParcelamentoEspecialParams,
  ParcelamentoNormalParams,
} from "../../types/Parcelamento";

export const queryKeys = {
  industries: ["industries"] as const,
  mixIdeal: ["mixIdeal"] as const,
  categories: ["categories"] as const,
  banners: ["banners"] as const,
  bannersToken: ["banners", "token"] as const,
  bannerPopups: ["bannerPopups"] as const,
  customers: ["customers"] as const,
  productByEan: (ean: string) => ["product", "ean", ean] as const,
  products: (params?: ProductParams | null, isCampanhaSolar?: string) =>
    ["products", params, isCampanhaSolar] as const,
  order: (isCampanhaSolar?: string) => ["order", isCampanhaSolar] as const,
  kitProducts: (params?: { ufKit: UfKit[] } | null) =>
    ["kitProducts", params] as const,
  clock: () => ["clock"] as const,
  pagamentoConfig: () => ["pagamento", "config"] as const,
  parcelamentoNormal: (params?: ParcelamentoNormalParams) =>
    ["parcelamentoNormal", params] as const,
  parcelamentoEspecial: (params?: ParcelamentoEspecialParams | null) =>
    ["parcelamentoEspecial", params] as const,
  intervalo: (params?: IntervaloParams | null) =>
    ["intervalo", params] as const,
  prazoMedio: (params?: PrazoMedioParams | null) =>
    ["prazoMedio", params] as const,
  condicoes: (params?: CondicoesParams | null) =>
    ["condicoes", params] as const,
};
